import {BookingModel} from "../../../../../booking.model";
import {NeatInsuranceProductModel} from "../../product/neat-insurance-product.model";
import {INeatProviderInfoRawData} from "../../raw-data/neat-raw-data.interfaces";
import {
    IBeginPaymentInsuranceSubscriptionRequest
} from "../../../../../../../airline-webapi/requests/begin-booking-payment.request";
import {INeatProductSubscriptionRequest} from "../../neat-subscription-request.interfaces";
import {IProviderSellStrategy} from "../../../../sell-strategies/provider-sell-strategy.model.interface";
import {BookingSessionStorageKeys} from "../../../../../storage/booking-session-storage-keys";
import {NullableString} from "../../../../../../../../types/nullable-types";
import {InsuranceSellContextEnum} from "../../../../insurance-sell-context.enum";
import {getNeatWebsitePage} from "../../neat-util-functions";


export abstract class NeatSellStrategyBaseModel  implements IProviderSellStrategy {
    constructor(public readonly providerCode: string,
                protected readonly booking: BookingModel,
                protected readonly availableProducts: NeatInsuranceProductModel[],
                private readonly providerInfoJson: INeatProviderInfoRawData,
                protected readonly _customerSessionId: string) {

    }


    protected abstract _getSelectedProduct(): NeatInsuranceProductModel | null;
    protected abstract _getSellContext(): InsuranceSellContextEnum;

    protected get services() {
        return this.booking.services;
    }

    buildSubscriptionRequest(): IBeginPaymentInsuranceSubscriptionRequest | null {
        const selectedProduct = this._getSelectedProduct();

        if(!selectedProduct) {
            return null;
        }

        const neatSubscriptionRequest = this._buildNeatSubscriptionRequest(selectedProduct);


        return {
            providerCode: this.providerCode,
            productSubscriptionRequestJson: JSON.stringify(neatSubscriptionRequest)
        }
    }

    protected _buildNeatSubscriptionRequest(selectedProduct: NeatInsuranceProductModel): INeatProductSubscriptionRequest {
        return {
            token: this.providerInfoJson.token,
            product: selectedProduct.productRawData,
            requestParamsJson: this._buildNeatSubscriptionRequestParams()
        }
    }

    protected _buildNeatSubscriptionRequestParams() {

        return {
            website_lang: this.services.language.currentLanguageIso2,
            website_page: getNeatWebsitePage(this._getSellContext()),
            customer_session_id: this._customerSessionId,
            customer_channel: this.services.layout.shouldUseWebappLayout ? "WEBSITE" : "MOBILE_APP"
        }
    }

    private _getStorageDiscriminator(): string {
        return `${this.providerCode}.${this._getSellContext()}`;
    }

    protected _setStorageItem(key: BookingSessionStorageKeys, value: string) {
        this.booking.storage.setItem(key, value, {
            discriminator: this._getStorageDiscriminator()
        });
    }

    protected _removeStorageItem(key: BookingSessionStorageKeys) {
        this.booking.storage.removeItem(key, {
            discriminator: this._getStorageDiscriminator()
        });
    }


    protected _getStorageItem(key: BookingSessionStorageKeys): NullableString {
        return this.booking.storage.getItem(key, {
            discriminator: this._getStorageDiscriminator()
        });
    }

    protected async _sellProduct(product: NeatInsuranceProductModel): Promise<void> {
        await this.booking.insurance.sellProduct(product, this._getSellContext());
    }

    protected async _removeProduct(product: NeatInsuranceProductModel): Promise<void> {
        await this.booking.insurance.removeProduct(product, this._getSellContext());
    }


}